import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';
import { Observable } from 'rxjs';
import { GetProductByMerchantFilteredRequest, GetProductByMerchantFilteredResponse } from 'app/models/product/get-product-by-merchant-filtered';
@Injectable()
export class ProductService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getProductsByMerchant(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminProduct/GetProductsByMerchant', data, messageService);
    }

    public getCategories(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/GetCategories', data, messageService);
    }

    public createProduct(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/CreateProduct', data, messageService);
    }

    public getTags(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminProduct/GetTags', data, messageService);
    }

    public getProductForEdit(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/Product/GetProductForEdit', data, messageService);
    }

    public updateProduct(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/UpdateProduct', data, messageService);
    }

    public deleteProduct(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminProduct/DeleteProduct', data, messageService);
    }

    public approvedOrRejectProductStatus(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminProduct/ApprovedOrRejectProductStatus', data, messageService);
    }
    public downloadProductsTemplate(data: any): Observable<any> {
        return this.apiHttp.postObservable('api/AdminProduct/GetProductsTemplate', data);
    }

    public uploadProductXls(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminProduct/UploadProductXls', data, messageService);
    }

    public validateProductXls(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminProduct/ValidateProductXls', data, messageService);
    }

    public uploadProductXlsToDb(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminProduct/UploadProductXlsToDb', data, messageService);
    }

    public createCategoryIfNotExists(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminProduct/CreateCategoryIfNotExists', data, messageService);
    }

    public getProductsByStore(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminProduct/GetProductsByStore', data, messageService);
    }

    public updateProductIsEnable(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminProduct/UpdateProductIsEnable', data, messageService);
    }

    public getProductByMerchantFiltered(data: GetProductByMerchantFilteredRequest, messageService: MessageService): Promise<GetProductByMerchantFilteredResponse> {
        return this.apiHttp.post('api/AdminProduct/GetProductByMerchantFiltered', data, messageService);
    }

}
